import { useParams, Link, Navigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { FadeInUp } from '../components/animations';
import SEO from '../components/SEO';
import { getBlogBySlug } from '../data/blogData';
import { articleSchema, breadcrumbSchema } from '../utils/schema';
import BlogPostHeader from '../components/blog/BlogPostHeader';
import BlogPostContent from '../components/blog/BlogPostContent';

const BlogPostPage = () => {
  const { slug } = useParams();
  const post = getBlogBySlug(slug);

  if (!post) return <Navigate to="/blog" replace />;

  return (
    <div className="pt-20" data-testid="blog-post-page">
      <SEO
        title={`${post.title} | Taiga Sourcing Blog`}
        description={post.excerpt}
        keywords={`India sourcing, ${post.category}, ${post.title.split(' ').slice(0, 5).join(' ')}`}
        path={`/blog/${slug}`}
        schema={[
          articleSchema(post, `/blog/${slug}`),
          breadcrumbSchema([
            { name: 'Home', path: '/' },
            { name: 'Blog', path: '/blog' },
            { name: post.title, path: `/blog/${slug}` },
          ]),
        ]}
      />

      <BlogPostHeader post={post} />

      {post.image && (
        <div className="max-w-5xl mx-auto px-6 lg:px-8 -mt-8 relative z-10">
          <img
            src={post.image}
            alt={post.title}
            className="w-full h-64 sm:h-80 lg:h-96 object-cover shadow-lg"
            loading="lazy"
          />
        </div>
      )}

      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <FadeInUp>
            <BlogPostContent content={post.content} />
          </FadeInUp>
        </div>
      </section>

      <section className="py-16 lg:py-24 bg-[#fafaf9]">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center">
          <FadeInUp>
            <h2
              className="text-2xl sm:text-3xl font-bold tracking-tight text-[#0B2A57] mb-4"
              style={{ fontFamily: 'Cabinet Grotesk' }}
            >
              HAVE A SOURCING REQUIREMENT?
            </h2>
            <p className="text-sm text-[#6B7280] mb-8">
              Share your requirement and let us find the right sourcing solution in India.
            </p>
            <Link
              to="/request-sourcing"
              className="inline-flex items-center gap-2 px-10 py-4 bg-[#0B2A57] text-white text-sm font-semibold tracking-wider uppercase transition-all hover:shadow-xl hover:-translate-y-0.5"
            >
              Request Sourcing
            </Link>
          </FadeInUp>
        </div>
      </section>
    </div>
  );
};

export default BlogPostPage;
